// extracted by mini-css-extract-plugin
module.exports = {"row":"HandbookRow_row__3V-7I","container":"HandbookRow_container__3Dcqc","checkbox":"HandbookRow_checkbox__xG2gT"};